import React from 'react';
import { THEME_CONFIG } from '../constants';

const PrivacyPolicy: React.FC = () => {
  return (
    <section id="privacy" className="py-20 bg-white dark:bg-gray-950">
      <div className="container mx-auto px-6 max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary dark:text-white">Política de Privacidad</h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 mt-4">
            Última actualización: {new Date().toLocaleDateString('es-ES')}
          </p>
        </div>
        <div className="prose dark:prose-invert max-w-none text-gray-700 dark:text-gray-300 space-y-4">
          <p>En {THEME_CONFIG.clinicName}, nos comprometemos a proteger la privacidad de nuestros pacientes. Esta Política de Privacidad describe cómo recopilamos, usamos y protegemos su información personal.</p>
          
          <h3 className="text-xl font-bold text-secondary dark:text-white">1. Información que Recopilamos</h3>
          <p>Recopilamos información que usted nos proporciona directamente, como su nombre, información de contacto, historial médico y datos de seguro, cuando agenda una cita o se registra como paciente.</p>

          <h3 className="text-xl font-bold text-secondary dark:text-white">2. Cómo Usamos su Información</h3>
          <p>Utilizamos su información para proporcionarle atención médica, procesar pagos, comunicarnos con usted sobre su tratamiento y para fines administrativos y de cumplimiento legal.</p>

          <h3 className="text-xl font-bold text-secondary dark:text-white">3. Confidencialidad y Seguridad</h3>
          <p>Mantenemos estrictas medidas de seguridad físicas, electrónicas y de procedimiento para proteger su información personal. El acceso a su información está restringido al personal autorizado que necesita conocerla para brindarle servicios.</p>

          <h3 className="text-xl font-bold text-secondary dark:text-white">4. Uso de Cookies</h3>
          <p>Nuestro sitio web puede utilizar cookies para mejorar la experiencia del usuario. Las cookies son pequeños archivos de texto que se almacenan en su dispositivo. Puede configurar su navegador para que rechace las cookies, pero esto puede afectar la funcionalidad de algunas partes de nuestro sitio.</p>

          <h3 className="text-xl font-bold text-secondary dark:text-white">5. Cambios a esta Política</h3>
          <p>Nos reservamos el derecho de modificar esta política de privacidad en cualquier momento. Cualquier cambio será publicado en esta página.</p>

          <h3 className="text-xl font-bold text-secondary dark:text-white">6. Contacto</h3>
          <p>Si tiene alguna pregunta sobre esta Política de Privacidad, puede contactarnos a través de la información proporcionada en nuestra sección de contacto.</p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;